import { Divider, Text } from '@mantine/core';
import * as React from 'react';
import { SerializableRenderTreeNode } from '../../../../../../react-commons/components/data-display/tree/RenderTreeNode';
import { Tree } from '../../../../../../react-commons/components/data-display/tree/Tree';
import { ValidationEntrySeverity } from '../../../../../../react-commons/components/ValidationEntrySeverity';
import { SplitPane } from '../../../../../../react-commons/views/split-pane/SplitPane';
import { ValidationResource } from '../../../../resource/resources/validation/detailedValidationResource';
import { ValidationResultSet } from '../../../../resource/services/backgroundTaskResource';
import { NothingSelectedComponent } from '../../NothingSelectedComponent';
import { ValidationResourceResultComponent } from './ValidationResourceResultComponent';

type DependencyValidationResultComponentTreeNode = SerializableRenderTreeNode<any>; // TODO

export const DependencyValidationResultComponent = ({
    dependencyValidationResult,
    height = '100%',
}: {
    dependencyValidationResult: ValidationResultSet;
    height?: number | string;
}) => {
    const [nodes, setNodes] = React.useState<Array<DependencyValidationResultComponentTreeNode>>([]);
    const [selectedNode, setSelectedNode] = React.useState<DependencyValidationResultComponentTreeNode | null>(null);
    const [selectedValidationResource, setSelectedValidationResource] = React.useState<ValidationResource | undefined>(
        undefined
    );

    React.useEffect(() => {
        if (dependencyValidationResult) {
            const parsedNodes = parseResourceTypes();
            setNodes(parsedNodes);
            if (parsedNodes.length > 0) {
                setSelectedNode(parsedNodes[0]);
            }
        }
    }, [dependencyValidationResult]);

    React.useEffect(() => {
        if (selectedNode?.data) {
            setSelectedValidationResource(selectedNode.data.validationResultMap);
        }
    }, [selectedNode]);

    const parseResourceTypes = () => {
        const groupNodes = Array<DependencyValidationResultComponentTreeNode>();
        Object.keys(dependencyValidationResult).forEach((groupName) => {
            const children = Array<DependencyValidationResultComponentTreeNode>();
            Object.keys(dependencyValidationResult[groupName]).forEach((persistableTypeGroup) => {
                Object.keys(dependencyValidationResult[groupName][persistableTypeGroup]).forEach((labelName) => {
                    const depValidationResult = dependencyValidationResult[groupName][persistableTypeGroup][labelName];
                    children.push({
                        key: `key_${depValidationResult.extract.id}_${groupName}_${persistableTypeGroup}_${labelName}`,
                        label: labelName,
                        data: {
                            extract: depValidationResult.extract,
                            validationResultMap: depValidationResult.validationResultMap,
                            domainType: persistableTypeGroup,
                        },
                        children: [],
                    });
                });
            });
            groupNodes.push({
                key: `key_${groupName}`,
                label: groupName,
                data: undefined,
                children,
            });
        });

        return groupNodes;
    };

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height,
            }}
        >
            <div
                style={{
                    overflow: 'hidden',
                    display: 'inline-block',
                    verticalAlign: 'top',
                    width: '100%',
                    flex: 1,
                }}
            >
                <SplitPane secondaryInitialSize={70}>
                    <div>
                        <Text style={{ paddingLeft: 5 }} c="dimmed">
                            Affected Resource Types
                        </Text>
                        <Divider style={{ marginBottom: 5 }} />
                        <Tree
                            nodes={nodes}
                            selectedNodeKey={selectedNode?.key}
                            onNodeSelected={(node) => setSelectedNode(node)}
                        />
                    </div>

                    <div
                        style={{
                            display: 'inline-block',
                            width: '100%',
                            height: '100%',
                            overflowY: 'auto',
                        }}
                    >
                        {selectedNode?.data?.domainType ?
                            <ValidationResourceResultComponent
                                resourceValidation={selectedValidationResource}
                                persistableTypeGroup={selectedNode.data.domainType}
                                maxSeverity={ValidationEntrySeverity.NOTE}
                            />
                        :   <NothingSelectedComponent />}
                    </div>
                </SplitPane>
            </div>
        </div>
    );
};
